export default __webpack_public_path__ + "static/media/gifos.f028de34.PNG";